/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import { useEffect } from "react";

import { reportClientErrorAsync } from "../../utils/error-reporting.utils";

export function GlobalErrorHandler(): null {
	useEffect(() => {
		// Handle unhandled promise rejections
		const handleUnhandledRejection = (event: PromiseRejectionEvent): void => {
			console.error("Unhandled promise rejection:", event.reason);

			const error = event.reason instanceof Error ? event.reason : new Error(String(event.reason));

			void reportClientErrorAsync(error);
		};

		// Handle uncaught JavaScript errors
		const handleUncaughtError = (event: ErrorEvent): void => {
			console.error("Uncaught error:", event.error);

			const error = event.error instanceof Error ? event.error : new Error(event.message || "Unknown error");

			void reportClientErrorAsync(error);
		};

		// Add event listeners
		window.addEventListener("unhandledrejection", handleUnhandledRejection);
		window.addEventListener("error", handleUncaughtError);

		// Cleanup function
		return () => {
			window.removeEventListener("unhandledrejection", handleUnhandledRejection);
			window.removeEventListener("error", handleUncaughtError);
		};
	}, []);

	return null; // This component doesn't render anything
}
